
import fixSafariOverflowScrolling from '../../utils/safari-fix'
import { mapState, mapActions } from 'vuex'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


import { Card, CardItem, MatchCard, RouteCard, CustomCard } from '../Common/Card'
import { QINIU_SERVER } from '../../config'

import Search from '../Common/Search.vue'
import RecommendLeague from '../Common/RecommendLeague.vue'
import CityTab from '../Common/CityTab.vue'
import QiniuImg from '../Common/QiniuImg.vue'

export default {
name: 'Recommend',
components: {
Search,
Swiper,
Tab,
TabItem,
Card,
CardItem,
MatchCard,
RouteCard,
CustomCard,
RecommendLeague,
CityTab,
QiniuImg,
},
data: () => ({
type: 'match',
/* width: 100% - image width - page-padding - card-padding */
width: (window.innerWidth || document.body.clientWidth) - 125 - 20 - 8,
swiper_index: 0,
}),
mounted() {
this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling')
fixSafariOverflowScrolling(this, 'touch')
},
computed: {
swiperList() {
return this.homeAd.map(ad => ({
img: `${QINIU_SERVER}${ad.img}`,
url: this.getAdUrl(ad),
}))
},
...mapState({
matches: ({ match }) => match.recommendMatch,
routes: ({ routes }) => routes.recommendRoutes,
customs: ({ custom }) => custom.customs,
categories: ({ custom }) => custom.categories,
homeAd: ({ adv }) => adv.home,
hotCities: ({ adv }) => adv.city,
homeFeatures: ({ adv }) => adv.feature,
recommendedLeagues: ({ league }) => league.recommend,
}),
customRouteType() {
if (this.categories) {
if (this.categories.find(category => category.categoryId === this.current)) {
return this.categories.find(category => category.categoryId === this.current)
.customRouteType
}
}
return 0
},
},
methods: {
...mapActions(['fetchRecommendRouteList', 'fetchRecommendMatchList', 'fetchLeagueList', 'fetchAds',
'showToast', 'fetchRecommendCustomList', 'fetchCustomRouteCategoryList']),
onSwip(index) {
const clone = document.querySelectorAll('.vux-swiper-item-clone')
for (let i = 0; i < clone.length; i += 1) {
clone[i].addEventListener('click', () => {
this.clickListItem(index)
})
}
this.swiper_index = index
},
clickListItem(index) {
this.$router.push(this.swiperList[index].url)
},
getAdUrl(ad) {
switch (ad.adType) {
case 1:
return `/match/${ad.targetId}`
case 3:
return `/route/${ad.targetId}`
case 4:
return `/header/search?q=${ad.keyword}`
case 5:
return `/header/search?city=${ad.keyword}`
case 6:
return null
case 7:
return `/tab/matches?leagueId=${ad.targetId}`
case 8:
return `/tab/custom?categoryId=${ad.targetId}`
default:
return ad.url
}
},
switchType(type) {
this.type = type
if (type === 'route') {
this.loadRecommendRouteList()
} else if (type === 'custom') {
this.loadRecommendCustomList()
} else {
this.loadRecommendMatchList()
}
},
loadRecommendMatchList() {
if (this.matches.length > 0) {
return
}
this.fetchRecommendMatchList().catch((err) => {
this.showToast({ content: err.body.resultInfo })
})
},
loadRecommendRouteList() {
if (this.routes.length > 0) {
return
}
this.fetchRecommendRouteList().catch((err) => {
this.showToast({ content: err.body.resultInfo })
})
},
loadRecommendCustomList() {
if (this.customs.length > 0) {
return
}
this.fetchRecommendCustomList().catch((err) => {
this.showToast({ content: err.body.resultInfo })
})
},
searchMatch(text) {
this.$router.push({
name: 'search-match',
query: {
q: text,
},
})
},
},
created() {
this.loadRecommendMatchList()

this.fetchCustomRouteCategoryList()

if (this.recommendedLeagues) {
this.fetchLeagueList()
}

this.fetchAds().catch((err) => {
this.showToast(err.body.resultInfo)
})
},
}



// WEBPACK FOOTER //
// ./client/components/Recommend/Recommend.vue